<template>
  <v-card
    elevation="2"
    class="mb-2"
  >
    <v-row
      align="center"
      justify="space-between"
      class="mx-2 pt-2"
    >
      <span class="subtitle-2 grey--text text--darken-2 text-uppercase">{{ processing["nm_processing"]}}</span>
      <v-menu
        offset-x
        transition="scale-transition"
        :close-on-content-click="false"
      >
        <template v-slot:activator="{on: menu}">
          <v-tooltip right>
            <template v-slot:activator="{on: tooltip}">
              <v-btn
                color="primary"
                icon
                v-on="{...menu, ...tooltip}"
              >
                <v-icon
                  :size="22"
                >
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
            <span>Ações no processamento</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-subheader>Ações</v-subheader>
          <v-list-item-group
            color="primary"
          >
            <flight-order-upload-dialog
              :processing="processing"
            >
              <template v-slot:activator="{ on: dialog }">
                <v-list-item
                  v-on="{...dialog}"
                  :disabled="processingEnded"
                >
                  <v-list-item-icon>
                    <v-icon
                      color="primary">mdi-image-multiple
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    Processar imagens
                  </v-list-item-content>
                </v-list-item>
              </template>
            </flight-order-upload-dialog>

            <v-list-item
              :to="`/app/order-processing/map/${processing['id_processing']}`"
              :disabled="!processingEnded"
            >
              <v-list-item-icon>
                <v-icon color="primary">mdi-eye</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                Visualizar processamento
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>
    </v-row>
    <v-row
      align="center"
      justify="start"
      class="mx-2 pb-2"
    >
      <v-col
        cols="12"
        class="pa-0 text-break text-left"
      >
        <v-icon
          :color="processingStatusIconColor"
          :size="22"
          :class="['mr-2', processingStatusClass]"
        >
          {{processingStatusIcon}}
        </v-icon>
        <span class="caption grey--text text--darken-2 text-uppercase">{{processingStatusText}}</span>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
  import {getFlightOrderProcessing} from "../../api/api-project"
  import {PROCESSING_STATUS_DETAILS, PROCESSING_STATUS} from "../../helpers/processings/constants"
  import {find} from "lodash/collection"
  import FlightOrderUploadDialog from "../FlightProvider/FlightOrderUploadDialog"
  import {isEqual} from "lodash/lang"

  export default {
    name: "FlightOrderProcessingItem",
    components: {
      FlightOrderUploadDialog
    },
    props: {
      flightOrderProcessing: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      processing: null,
      tries: 0,
    }),
    methods: {
      getFlightOrderProcessingRecursive() {
        const maxTries = 2

        if (maxTries <= this.tries) return

        getFlightOrderProcessing(this.$apiAuth.getAuthToken(), this.flightOrderProcessing.cd_processing)
          .then((resp) => {
            this.processing = resp.data.data
          })
          .catch(() => {
            setTimeout(() => {
              this.getFlightOrderProcessingRecursive()
            }, 750)
          })
          .finally(() => {
            this.tries += 1
          })
      }
    },
    computed: {
      processingStatusIcon() {
        return find(PROCESSING_STATUS_DETAILS, ["value", this.processing["ab_processing_status"]]).icon
      },
      processingStatusClass() {
        return find(PROCESSING_STATUS_DETAILS, ["value", this.processing["ab_processing_status"]]).class
      },
      processingStatusIconColor() {
        return find(PROCESSING_STATUS_DETAILS, ["value", this.processing["ab_processing_status"]]).color
      },
      processingStatusText() {
        return find(PROCESSING_STATUS_DETAILS, ["value", this.processing["ab_processing_status"]]).name
      },
      processingEnded() {
        return isEqual(this.processing["ab_processing_status"], PROCESSING_STATUS.ENDED)
      },
    },
    mounted() {
      this.getFlightOrderProcessingRecursive()
    }
  }

</script>

<style scoped>

</style>
